import get from 'lodash.get';

import { emptyObject } from '../../default-props/empty';

export const getSelectedFulfillmentPlanId = (state) => get(state, 'fulfillmentPlanId', '');
export const selectCostReviewGuid = (state) => get(state, 'costReviewJobGuid', emptyObject);
